<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <div class="content">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <el-form :model="infoForm" :rules="infoRules" ref="infoForm" label-width="120px" class="info-form">
        <el-form-item label="模板名称">
          <el-input placeholder="请输入模板名称" v-model="form.name" style="width: 30%" maxlength="20"
            show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="是否包邮">
          <el-radio-group v-model="form.isFree">
            <el-radio :label="0">自定义邮费</el-radio>
            <el-radio :label="1">包邮</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="是否同步平台">
          <el-radio-group v-model="form.isSync">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="运送方式" v-if="form.isFree == 0">
          <el-checkbox v-model="form.type" onclick="return false;">
            快递（除指定地区外，其余地区的运费采用“默认运费”）</el-checkbox>
        </el-form-item>
        <el-form-item label="邮费设置" v-if="form.isFree == 0">
          <el-radio-group v-model="form.calculType" @change="selectType">
            <el-radio :label="1">按件数</el-radio>
            <el-radio :label="2">按重量</el-radio>
          </el-radio-group>
          <number v-if="form.calculType == 1 && this.$route.query.type == 'edit'" @change="handleChange($event, '1')"
            :tableData="tableData" :freight="freight1" :baseNumber="baseNumber1" :addNum="addNum1" :addPrice="addPrice1"
            :key="Math.random()"></number>
          <number v-if="form.calculType == 1 && this.$route.query.type == 'add'" @change="handleChange($event, '1')"
            :tableData="tableData" :freight="freight1" :baseNumber="baseNumber1" :addNum="addNum1" :addPrice="addPrice1">
          </number>
          <weight v-if="form.calculType == 2 && this.$route.query.type == 'edit'" @change="handleChange($event, '2')"
            :tableData="tableData2" :freight="freight2" :baseNumber="baseNumber2" :addNum="addNum2" :addPrice="addPrice2"
            :key="Math.random()"></weight>
          <weight v-if="form.calculType == 2 && this.$route.query.type == 'add'" @change="handleChange($event, '2')"
            :tableData="tableData2" :freight="freight2" :baseNumber="baseNumber2" :addNum="addNum2" :addPrice="addPrice2">
          </weight>
        </el-form-item>

        <el-form-item label="" v-if="form.isFree == 0">
          <el-radio v-model="form.hasFree" :label="true">指定条件包邮（可选）</el-radio>
          <free-delivery @change="handleChangeZ" :tableData="tableDataF"></free-delivery>
        </el-form-item>
      </el-form>
      <div style="width: 30%; text-align: center; padding-bottom: 20px">
        <el-button type="primary" @click="submit()">确认</el-button>
        <el-button @click="back">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import FreeDelivery from '../components/freeDelivery.vue'
import number from '../components/number.vue'
import weight from '../components/weight.vue'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    number,
    weight,
    FreeDelivery
  },
  data() {
    return {
      dataList: {
        list: [
          { title: '商品管理', path: '', type: '0' },
          { title: '运费模板', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '新增运费模板', path: '', type: '0' }
        ]
      },
      infoForm: null,
      infoRules: {},
      form: {
        name: '',
        isFree: 0,
        isSync: 1,
        type: true,
        calculType: 1,
        hasFree: false,
      },
      checked1: false,
      checked2: false,
      radio: 3,
      name: '---',
      dialogUser: false,
      currentPage4: 1,
      tableData: [

      ],
      tableData2: [

      ],
      tableDataF: [

      ],
      freight1: null,
      baseNumber1: null,
      addNum1: null,
      addPrice1: null,
      freight2: null,
      baseNumber2: null,
      addNum2: null,
      addPrice2: null,
      regions: [],
      freeList: [],
      time: 0,
      detail: {
        firstNum: 0,
        baseNumber: 0,
        freight: 0,
        type: 0,
        addPrice: 0,
        addNum: 0,
      },
    }
  },
  watch: {
    form: {
      handler(newVal, oldVal) {

      },
      deep: true,
    },
  },
  created() {
    if (this.$route.query.type == 'add') {
      this.searchList.list[0].title = '新增运费模板'
    } else {
      this.searchList.list[0].title = '编辑运费模板'
      this.getDetail()
    }
  },
  methods: {
    selectType() {
      // this.tableData = []
      // this.tableDataF = []
      // this.tableData = this.tableData
      // this.tableDataF = this.tableDataF
    },
    getDetail() {
      this.axios.post('/shippingTemplate/get', { id: this.$route.query.id }).then(res => {
        this.detail = res.data
        this.form.name = this.detail.name
        this.form.isFree = this.detail.isFree
        this.form.isSync = this.detail.isSync

        if (this.detail.type == 1) {
          this.form.type = true
        } else {
          this.form.type = false
        }

        this.form.calculType = this.detail.calculType
        this.form.hasFree = this.detail.hasFree
        if (this.form.calculType == 1) {
          this.freight1 = Number(this.detail.freight)
          this.baseNumber1 = Number(this.detail.baseNumber)
          this.addNum1 = Number(this.detail.addNum)
          this.addPrice1 = Number(this.detail.addPrice)
          console.log(this.freight1)
          this.freight2 = 0
          this.baseNumber2 = 0
          this.addNum2 = 0
          this.addPrice2 = 0
          this.tableData = this.detail.regions || []
          console.log(this.tableData)
          if (this.tableData) {
            this.tableData.forEach(item => {
              Object.assign(item, { address: item.betterAddress })
              Object.assign(item, { addressData: JSON.parse(item.regionJson) })
            })
          }
        } else {
          this.freight1 = 0
          this.baseNumber1 = 0
          this.addNum1 = 0
          this.addPrice1 = 0
          this.freight2 = Number(this.detail.freight)
          this.baseNumber2 = Number(this.detail.baseNumber)
          this.addNum2 = Number(this.detail.addNum)
          this.addPrice2 = Number(this.detail.addPrice)
          this.tableData2 = this.detail.regions || []
          console.log(this.tableData2)
          if (this.tableData2) {
            this.tableData2.forEach(item => {
              Object.assign(item, { address: item.betterAddress })
              Object.assign(item, { addressData: JSON.parse(item.regionJson) })
            })
          }
        }

        this.detail.addPrice = Number(this.detail.addPrice)


        // this.freight = this.detail.freight,
        //   this.baseNumber = this.detail.baseNumber,
        //   this.addNum = this.detail.addNum,
        //   this.addPrice = this.detail.addPrice,

        this.tableDataF = this.detail.freeList || []
        if (this.tableDataF) {
          this.tableDataF.forEach(item => {
            Object.assign(item, { address: item.betterAddress })
            Object.assign(item, { addressData: JSON.parse(item.regionJson) })
          })
        }
        this.$forceUpdate()

      })
    },
    handleChange(val, type) {
      console.log(val)
      if (type == 1) {
        this.freight1 = Number(val.freight)
        this.baseNumber1 = Number(val.baseNumber)
        this.addNum1 = Number(val.addNum)
        this.addPrice1 = Number(val.addPrice)
      } else {
        this.freight2 = Number(val.freight)
        this.baseNumber2 = Number(val.baseNumber)
        this.addNum2 = Number(val.addNum)
        this.addPrice2 = Number(val.addPrice)
      }
      // this.freight = val.freight
      // this.baseNumber = val.baseNumber,
      //   this.addNum = val.addNum,
      //   this.addPrice = val.addPrice,
      this.regions = []
      console.log(val.tableData)
      let arr = val.tableData
      if (arr) {
        arr.forEach(item => {
          let address = ''
          console.log(JSON.parse(item.regionJson))
          if (JSON.parse(item.regionJson)) {
            Array.from(JSON.parse(item.regionJson)).forEach(itm => {
              if (address == '') {
                address = itm.province + '-' + itm.label
              } else {
                address = address + ',' + itm.province + '-' + itm.label
              }
              // item.address = address
              // regionJson.push(itm)
            })
          }
          console.log(address)
          // item.address = address
          let obj = {
            address: address,
            firstNum: item.firstNum,
            freight: item.freight,
            addNum: item.addNum,
            addPrice: item.addPrice,
            regionJson: item.regionJson

          }
          this.regions.push(obj)
          // if (this.$route.query.type == 'edit') {
          //   let obj = {
          //     address: item.address,
          //     firstNum: item.firstNum,
          //     freight: item.freight,
          //     addNum: item.addNum,
          //     addPrice: item.addPrice,
          //     regionJson: JSON.stringify(item.regionJson)

          //   }
          //   this.regions.push(obj)
          // } else {
          //   let obj = {
          //     address: item.address,
          //     firstNum: item.firstNum,
          //     freight: item.freight,
          //     addNum: item.addNum,
          //     addPrice: item.addPrice,
          //     regionJson: JSON.stringify(item.regionJson)
          //   }
          //   this.regions.push(obj)
          // }
          // let obj = {
          //   address: address,
          //   firstNum: item.firstNum,
          //   freight: item.freight,
          //   addNum: item.addNum,
          //   addPrice: item.addPrice,
          //   regionJson: item.regionJson
          // }

        })
        console.log(this.regions)
      }

    },
    handleChangeZ(val) {
      console.log(val)
      this.freeList = []
      let arr = []
      arr = val
      console.log(arr)
      // let regionJson = []
      arr.forEach(item => {
        let address = ''
        console.log(JSON.parse(item.regionJson))
        if (JSON.parse(item.regionJson)) {
          Array.from(JSON.parse(item.regionJson)).forEach(itm => {
            if (address == '') {
              address = itm.province + '-' + itm.label
            } else {
              address = address + ',' + itm.province + '-' + itm.label
            }
            // item.address = address
            // regionJson.push(itm)
          })
        }
        console.log(address)
        let obj = {
          address: address,
          type: item.type,
          calculType: item.calculType,
          price: item.num,
          num: item.num,
          regionJson: item.regionJson
        }
        this.freeList.push(obj)
      })
    },
    back() {
      this.$router.go(-1)
    },
    submit() {
      if (this.time == 0) {
        this.time = 3; //设定间隔时间（秒）
        //启动计时器，倒计时time秒后自动关闭计时器。
        var index = setInterval(function () {
          this.time--;
          if (this.time == 0) {
            clearInterval(index);
          }
        }, 1000);
        //此处可写要执行的代码
        let baseNumber = 0
        let addNum = 0
        let freight = 0
        let addPrice = 0
        if (this.detail.calculType == 1) {
          baseNumber = this.baseNumber1
          addNum = this.addNum1
          freight = this.freight1
          addPrice = this.addPrice1
        } else {
          baseNumber = this.baseNumber2
          addNum = this.addNum2
          freight = this.freight2
          addPrice = this.addPrice2
        }
        let data = {
          name: this.form.name,
          isFree: this.form.isFree,
          isSync: this.form.isSync,
          type: 1,
          calculType: this.form.calculType,
          hasFree: this.form.hasFree,
          freight: freight,
          baseNumber: baseNumber,
          addNum: addNum,
          addPrice: addPrice,
          regions: this.regions,
          freeList: this.freeList
        }
        console.log(this.regions)
        if (this.$route.query.type == 'edit') {
          data.id = this.$route.query.id
        }
        this.axios.post('/shippingTemplate/addEdit', data).then(res => {
          if (res.code == 0) {
            if (this.$route.query.type == 'edit') {
              this.$message({ type: 'success', message: '编辑成功' })
            } else {
              this.$message({ type: 'success', message: '添加成功' })
            }

            this.$router.push({
              name: 'transportationModel',
              query: {}
            })
          } else {
            this.time = 0
          }

        })
      } else {
        console.log('目前按钮事件不允许被触发');
      }

    }
  }
}
</script>
<style scoped>
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #2d46ee;
}

.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}
</style>

